import { name } from "./constant";

export const signal = signalName => ({
  type: `${name}:${signalName}`
});
